/*
 * Visual 360 — inizializzazione del viewer tramite la libreria HSL di Hyphen
 * (metodo di re-inizializzazione, quello consigliato nella documentazione).
 *
 * Il bottone overlay apre il modale nativo del tema (<modal-opener> / theme.js).
 * Al primo click inizializziamo il plugin jQuery HSL passando l'URL del
 * pacchetto Viewer360 esportato (metafield prodotto chalco.visual_360). HSL
 * scarica quell'HTML, ne fa il parse e renderizza il viewer nel container.
 *
 * HSL dimensiona il viewer dalla misura del container al momento dell'init
 * (i layer immagine .ui-360-bg/.ui-360-fg sono position:absolute, quindi il
 * container DEVE avere già dimensioni reali). Poiché il modale full-screen può
 * non aver completato il layout subito dopo l'apertura, aspettiamo che il
 * container riporti width/height > 0 prima di chiamare .hsl().
 */
(function () {
  if (window.__visual360Init) return;
  window.__visual360Init = true;

  // hsl.js usa internamente window.jQuery: liberiamo "$" senza rimuoverlo.
  if (window.jQuery && !window.__visual360NoConflict) {
    window.__visual360NoConflict = true;
    try {
      window.jQuery.noConflict();
    } catch (e) {}
  }

  // Device realmente touch? La detection interna di HSL (Hyphen.isMobile) si basa
  // SOLO sullo user-agent e non usa navigator.maxTouchPoints: su webview/in-app o
  // in emulazione DevTools cade a false e la rotazione touch non viene cablata.
  // Ci basiamo invece sul puntatore reale (coarse = touch primario), così NON
  // regrediamo il desktop mouse (fine) né i touch-laptop (puntatore primario fine).
  function isCoarsePointer() {
    try {
      if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
    } catch (e) {}
    return navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
  }

  // Chiama cb() quando l'elemento ha una dimensione reale E STABILE (stesse
  // dimensioni per due frame consecutivi): evita che HSL misuri un valore
  // transitorio del box (reflow del 100dvh su mobile) e centri l'immagine su una
  // geometria sbagliata. Fallback dopo N frame.
  function whenSized(el, cb, attempts, lastW, lastH) {
    if (attempts == null) attempts = 60;
    var w = el.offsetWidth;
    var h = el.offsetHeight;
    var stable = w > 0 && h > 0 && w === lastW && h === lastH;
    if (stable || attempts <= 0) {
      cb();
      return;
    }
    requestAnimationFrame(function () {
      whenSized(el, cb, attempts - 1, w, h);
    });
  }

  function initViewer(modal) {
    var viewer = modal.querySelector('[data-visual-360-viewer]');
    if (!viewer || viewer.hasAttribute('data-initialized')) return;

    var url = viewer.getAttribute('data-url');
    if (!url) return;

    var jq = window.jQuery;
    if (!jq || !jq.fn || !jq.fn.hsl) return;

    // Segna subito come inizializzato: blocca il re-init anche mentre attendiamo
    // che il container abbia dimensioni valide.
    viewer.setAttribute('data-initialized', '');

    whenSized(viewer, function () {
      jq(viewer).hsl({
        url: url,
        isTouchScreenMonitor: isCoarsePointer(), //Forza la modalità touch di HSL sui device a puntatore coarse, indipendentemente dallo user-agent (rotazione touch su mobile/webview/emulazione)
        withCredentials: false, //Abilita/disabilita l'invio dei cookie di autenticazione al server nel caso l'export sia su dominio diverso (CDN)
        autoRotation: false, //Abilita/disabilita rotazione automatica, giro singolo iniziale
        allowRotation: true, //Abilita/disabilita rotazione con il mouse nascondendo anche la barra di rotazione
        resetOnMouseout:  false, //Reset alle impostazioni iniziali al mouseout
        fullScreen: false, //OFF: il modale è già full-screen via CSS. Con true HSL sposta il viewer nel <body> (.ui-360-fullsize, z-index 99999) coprendo il bottone di chiusura del modale.
        hasButtons: false, //Forza la visualizzazione dei bottoni
        mouseOutDisabled:  false, //Abilita/disabilita la funzionalità di mouseout (nasconde/visualizza interfaccia al mouseout/mousein)
        useDefaultGui: false, //Abilita/disabilita interfaccia custom definita nel parametro customGui
        quickZoom: false, //Abilita/disabilita la funzionalità di quickzoom (se true la funzionalità di selezione area per lo zoom non è abilitata)
        customGui:{ //Questi settings devono essere definiti se useDefaultGui == false
          showTitle: false, //Abilita/disabilita visualizzazione del titolo in overlay
          typeIconClass:[""], //Possibilità di aggiungere classi specifiche per l'icona della tipologia
          type: "ROTATION",
          title: "ROTATION", //Testo libero
          barClass:["customBar"], //Possibilità di aggiungere classi specifiche per la barra dei comandi
          quickZoomClass: ["customQuickZoom", "fa", "fa-search-plus"], //Possibilità di aggiungere classi specifiche per l'icona di quick-zoom
          zoomInClass: ["customZoomIn", "fa", "fa-search-plus", "hidden"], //Possibilità di aggiungere classi specifiche per l'icona di zoom-in
          zoomOutClass:["customZoomOut", "fa", "fa-search-minus", "hidden"], //Possibilità di aggiungere classi specifiche per l'icona di zoom-out
          panClass:["customPan", "fa", "fa-hand-pointer-o"], //Possibilità di aggiungere classi specifiche per l'icona di pan
          rotationClass:["customRotation"], //Possibilità di aggiungere classi specifiche per la barra di rotazione
          fullScreenClass:["customFullScreen", "fa", "fa-expand"], //Possibilità di aggiungere classi specifiche per l'icona di fullscreen
          exitFullScreenClass:["customExitFullScreen", "fa", "fa-compress"], //Possibilità di aggiungere classi specifiche per l'icona di exit fullscreen
        }
      });
    });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-visual-360-opener]');
    if (!opener) return;

    var selector = opener.getAttribute('data-modal');
    if (!selector) return;

    var modal = document.querySelector(selector);
    if (!modal) return;

    // Il modale nativo si apre in modo sincrono al click (theme.js -> show());
    // initViewer attende poi che il container abbia dimensioni reali.
    initViewer(modal);
  });
})();
